import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ValidateOtpreq } from '../req/validate-otpreq.model';

@Injectable({
  providedIn: 'root'
})
export class ValidateOtpserviceService {

  Url: string = "https://atikaxgfk6.execute-api.ap-south-1.amazonaws.com/dev/superadmin/validatesignupotp";
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization':localStorage.getItem("sessiontoken"),
      'x-api-key':localStorage.getItem("clientid")
     
    })
  };
  http: any;
  constructor(private httpClient : HttpClient) { }
  OtpValidation(otpreq: ValidateOtpreq) {
    return this.httpClient.post(this.Url, otpreq, this.httpOptions);
  }
  

}
